import { render, staticRenderFns } from "./status_dropdown.vue?vue&type=template&id=5fb8d487"
import script from "./status_dropdown.vue?vue&type=script&lang=js"
export * from "./status_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports